module.exports = __webpack_public_path__ + "static/media/irises.6e493317.jpg";